// /v2/board → flow-specific board redirect (board-split Phase 1).
//
// Reads the principal's enabledFlows and forwards to the first enabled flow's
// board. Defaults to People when the list is empty or the lookup fails —
// pre-split muscle memory (and every internal '/v2/board' link) keeps working.
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import useApi from '../hooks/useApi';
import { fetchMyPrincipal } from '../services/api';

const BOARD_PATH_BY_FLOW = {
  coach: '/v2/board/people',
  business: '/v2/board/businesses',
};

export default function AviaryV2BoardRedirectPage() {
  const api = useApi();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      let firstFlow = 'coach';
      try {
        const principal = await fetchMyPrincipal(api);
        const flows = Array.isArray(principal?.enabledFlows) ? principal.enabledFlows : [];
        if (flows[0] === 'business' || flows[0] === 'coach') firstFlow = flows[0];
      } catch (_err) {
        // Lookup failed — fall through to the People default.
      }
      if (cancelled) return;
      const target = BOARD_PATH_BY_FLOW[firstFlow] || BOARD_PATH_BY_FLOW.coach;
      // Preserve query params (e.g. ?lane=connected deep links from Today page).
      navigate(`${target}${location.search || ''}`, { replace: true });
    })();
    return () => { cancelled = true; };
  }, [api, navigate, location.search]);

  return <Center py={80}><Loader color="sage" /></Center>;
}
